import Container from "../../../Components/Container";
import Row from "../../../Components/Row";
import ButtonTestFree from "../../../Components/ButtonTestFree";
import BannerSite from "../../../assets/images/mock_follow.svg";
import { ResponsiveImage, Subtitle, Title } from "./styles";

const FollowUpHero = () => {
  return (
    <Container
      style={{ textAlign: "center", background: "#000000" }}
      id="section-12"
    >
      <Row
        xs="1fr"
        sm="1fr"
        md="1fr 38%"
        lg="1fr 38%"
        xl="1fr 38%"
        style={{ marginTop: "80px" }}
      >
        <div>
          <Title>
            Follow-ups inteligentes que recuperam clientes no{" "}
            <span style={{ color: "#E4DA1B", fontWeight: 600 }}>
              piloto automático.
            </span>
          </Title>
          <Subtitle>
            O Alfred analisa conversas, identifica oportunidades e dispara
            mensagens personalizadas no Whatsapp automaticamente. Sem spam. Sem
            fluxos engessados.
          </Subtitle>
          <ButtonTestFree />
          <br />
        </div>
        <div>
          <ResponsiveImage src={BannerSite} alt="banner" />
        </div>
      </Row>
    </Container>
  );
};

export default FollowUpHero;
